<template>
  <div>
    <div v-if="hasError" class="error--text">Unable to {{ type }} traffic rule. Please try again</div>

    <toggle-input
      v-model="rule.automatic"
      :disabled="isLoading"
      label="Global Rule"
      class="mt-3 mb-9"
      hide-details
      outlined
    />

    <autocomplete-input
      :disabled="isDisabled"
      :items="trafficOptions"
      :value="rule.type"
      label="I want to..."
      class="mt-5"
      @input="onInput('type', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="offerTypes"
      :value="rule.offerType"
      label="For offer type"
      class="mt-5"
      @input="onInput('offerType', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="mappedSites"
      :value="rule.site"
      label="To this specific site"
      class="mt-5"
      @input="onInput('site', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="siteTypes"
      :value="rule.siteType"
      label="For site type"
      class="mt-5"
      @input="onInput('siteType', $event)"
    />

    <text-input
      v-if="rule.type === 'receive'"
      :disabled="isDisabled"
      :value="rule.percentage"
      label="Percentage of traffic"
      class="mt-5"
      @input="onInput('percentage', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="mappedPartners"
      :value="rule.partner"
      label="To this partner"
      class="mt-5"
      @input="onInput('partner', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="mappedOffers"
      :value="rule.offer"
      label="To this specific offer"
      class="mt-5"
      @input="onInput('offer', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="getItemsForOption('countries')"
      :value="rule.geo"
      label="For this country"
      class="mt-5"
      @input="onInput('geo', $event)"
    />

    <autocomplete-input
      :disabled="isDisabled || !rule.type"
      :items="getItemsForOption('languages')"
      :value="rule.language"
      label="For this language"
      class="mt-5"
      @input="onInput('language', $event)"
    />

    <text-input
      v-if="rule.type === 'receive'"
      :disabled="isDisabled"
      :value="rule.priority"
      label="In priority"
      class="mt-5"
      @input="onInput('priority', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AutocompleteInput from '@/components/forms/autocomplete-input'
import TextInput from '@/components/forms/text-input'
import ToggleInput from '@/components/forms/toggle-input'

export default {
  name: 'RuleForm',
  components: {
    AutocompleteInput,
    TextInput,
    ToggleInput,
  },
  model: {
    prop: 'rule',
  },
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    partners: {
      type: Array,
      required: true,
    },
    offers: {
      type: Array,
      required: true,
    },
    offerTypes: {
      type: Array,
      required: true,
    },
    siteTypes: {
      type: Array,
      required: true,
    },
    sites: {
      type: Array,
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'create',
      validator(val) {
        return ['create', 'edit'].includes(val)
      },
    },
    rule: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    trafficOptions: [
      { key: 'Direct traffic', value: 'receive' },
      { key: 'Limit traffic', value: 'block' },
      { key: 'Block traffic', value: 'fullBlock' },
    ],
    globalOptions: [
      { key: 'Global', value: true },
      { key: 'Local', value: false },
    ],
  }),
  computed: {
    ...mapGetters('options', ['getItemsForOption']),
    mappedPartners() {
      return this.partners.map(({ name, slug }) => ({ key: name || slug, value: slug }))
    },
    mappedOffers() {
      return this.offers.map(({ name, type, slug }) => ({ key: `${name} (${type})`, value: slug }))
    },
    mappedSites() {
      return this.sites.map(({ name, hostname }) => ({ key: name || hostname, value: hostname }))
    },
  },
  methods: {
    onInput(key, value) {
      const merged = Object.assign({}, this.rule, { [key]: value })
      this.$emit('input', merged)
    },
  },
}
</script>
